import React from 'react';
import { Typography } from '@material-ui/core'; // Import Typography from your UI library
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { AllClientsFields } from 'modules/clients/interfaces';

interface ClickTypographyProps {
  item: AllClientsFields;
  value: string | number;
  classes: ClassNameMap;
  handleClick: (item: AllClientsFields, url: string) => void;
}

const ClickTypography: React.FC<ClickTypographyProps> = ({
  item,
  value,
  classes,
  handleClick,
}) => {
  return (
    <Typography
      className={classes.tableLine}
      onClick={() => {
        handleClick(item, `/clients/${item.client_uuid}/configurations`);
      }}
    >
      {value}
    </Typography>
  );
};

export default ClickTypography;
